import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CultureCustomsCard, LoadMoreButton } from '../components';
import { Skeleton } from '../components/ui/skeleton';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

// Import required modules
import { Pagination, Autoplay } from 'swiper/modules';

const CultureCustomsSlider = ({ data, onToggleFavorite, isLoading }) => {
  const [slidesPerView, setSlidesPerView] = useState(1); // Initialize state

  const handleLoadMore = () => {
    console.log(`Load ${slidesPerView} More Clicked!`);
  };

  const handleSwiperInit = (swiper) => {
    const initialSlidesPerView = swiper.params.slidesPerView;
    setSlidesPerView(initialSlidesPerView);
  };

  const handleSwiperResize = (swiper) => {
    const currentSlidesPerView = swiper.currentBreakpoint
      ? swiper.params.breakpoints[swiper.currentBreakpoint].slidesPerView
      : swiper.params.slidesPerView;
    setSlidesPerView(currentSlidesPerView);
  };
  
  return (
    <div className="mt-6">
      <div className="flex justify-between mb-3">
        {isLoading ? (
          <Skeleton className="w-32 h-5" />
        ) : (
          <h5 className="text-base font-bold leading-5 text-gray-900">
            {data.title}
          </h5>
        )}
        {isLoading ? (
          <Skeleton className="w-16 h-4" />
        ) : (
          <a href={data.link} className="text-sm font-medium text-gold-300">
            View all
          </a>
        )}
      </div>

      {isLoading ? (
        <div className="flex space-x-4">
          {[...Array(3)].map((_, index) => (
            <Skeleton key={index} className="w-full rounded-lg h-60" />
          ))}
        </div>
      ) : (
        <Swiper
          onInit={handleSwiperInit} // Initialize Swiper
          onResize={handleSwiperResize} // Handle resize
          slidesPerView={1}
          slidesPerGroup={1}
          spaceBetween={16}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1281: { slidesPerView: 3 },
          }}
          modules={[Pagination, Autoplay]}
          className="culture-card-slider"
        >
          {data.items.map((item, index) => (
            <SwiperSlide key={index}>
              <CultureCustomsCard
                id={item.id}
                slug={item.slug}
                title={item.title}
                catList={item.catList}
                favorite={item.favorite}
                imageUrl={item.imageUrl}
                onToggleFavorite={onToggleFavorite}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/* <div className="flex justify-center">
        {isLoading ? (
          <Skeleton className="w-32 h-10 mt-3 rounded-md" />
        ) : (
          <LoadMoreButton
            label={`Load ${slidesPerView} More`}
            onClick={handleLoadMore}
          />
        )}
      </div> */}
    </div>
  );
};

export default CultureCustomsSlider;
